/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Web_Scraping_TaglineInputs */

const en_svc_web_scraping_tagline = /** @type {(inputs: Svc_Web_Scraping_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Structured data from any site, including ones that don't want to give it up easily.`)
};

const ar_svc_web_scraping_tagline = /** @type {(inputs: Svc_Web_Scraping_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بيانات منظمة من أي موقع, بما في ذلك تلك التي لا تتخلى عنها بسهولة.`)
};

const bn_svc_web_scraping_tagline = /** @type {(inputs: Svc_Web_Scraping_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`যেকোনো সাইট থেকে স্ট্রাকচার্ড ডেটা, যেগুলো সহজে ছাড়তে চায় না সেগুলো থেকেও।`)
};

const de_svc_web_scraping_tagline = /** @type {(inputs: Svc_Web_Scraping_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strukturierte Daten von jeder Website, auch von solchen, die sie nicht freiwillig herausgeben.`)
};

const es_svc_web_scraping_tagline = /** @type {(inputs: Svc_Web_Scraping_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datos estructurados de cualquier sitio, incluidos aquellos que no quieren renunciar a ellos fácilmente.`)
};

const fr_svc_web_scraping_tagline = /** @type {(inputs: Svc_Web_Scraping_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Données structurées de n'importe quel site, y compris ceux qui ne veulent pas y renoncer facilement.`)
};

const pt_svc_web_scraping_tagline = /** @type {(inputs: Svc_Web_Scraping_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dados estruturados de qualquer site, inclusive aqueles que não entregam facilmente.`)
};

const zh_svc_web_scraping_tagline = /** @type {(inputs: Svc_Web_Scraping_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`任何站点要结构化数据都拿得到，包括那些不愿交出数据的站点。`)
};

const tr_svc_web_scraping_tagline = /** @type {(inputs: Svc_Web_Scraping_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kolay vazgeçmeyenler dahil her siteden yapısal veri.`)
};

const ru_svc_web_scraping_tagline = /** @type {(inputs: Svc_Web_Scraping_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Структурные данные с любого сайта, включая те, что не хотят легко расставаться.`)
};

const pl_svc_web_scraping_tagline = /** @type {(inputs: Svc_Web_Scraping_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uporządkowane dane z dowolnej witryny, także takiej, która nie chce ich łatwo oddać.`)
};

/**
* | output |
* | --- |
* | "Structured data from any site, including ones that don't want to give it up easily." |
*
* @param {Svc_Web_Scraping_TaglineInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_web_scraping_tagline = /** @type {((inputs?: Svc_Web_Scraping_TaglineInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Web_Scraping_TaglineInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_web_scraping_tagline(inputs)
	if (locale === "bn") return bn_svc_web_scraping_tagline(inputs)
	if (locale === "de") return de_svc_web_scraping_tagline(inputs)
	if (locale === "es") return es_svc_web_scraping_tagline(inputs)
	if (locale === "fr") return fr_svc_web_scraping_tagline(inputs)
	if (locale === "pt") return pt_svc_web_scraping_tagline(inputs)
	if (locale === "zh") return zh_svc_web_scraping_tagline(inputs)
	if (locale === "tr") return tr_svc_web_scraping_tagline(inputs)
	if (locale === "ru") return ru_svc_web_scraping_tagline(inputs)
	if (locale === "pl") return pl_svc_web_scraping_tagline(inputs)
	return en_svc_web_scraping_tagline(inputs)
});
export { svc_web_scraping_tagline as "svc_web-scraping_tagline" }